import { combineReducers, configureStore } from "@reduxjs/toolkit";
import LoaderReducer from "./LoadingReducer/LoaderReducer";
import MsgReducer from "./MessageReducer/MsgReducer";
import AccountReducer from "./AuthReducer/AuthReducer";
import { UserReducer } from "./UserReducer/UserReducer";

const rootReducer = combineReducers({
  LoaderReducer: LoaderReducer,
  MessageReducer: MsgReducer,
  AccountReducer:AccountReducer,
  UserReducer:UserReducer,
});

const Store = configureStore({
  reducer: rootReducer,
});

export default Store
